import { RkVideoMobilePlayer } from "@ugc-ui/lego";
import { useStores } from "@client/store";
import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { ModalContentWrapper } from "@common/components/Modal/ModalTemplate/ModalContentWrapper/ModalContentWrapper";
import { useIsMobile } from "@common/hooks/isMobile";
import { Modal } from "@common/components/Modal/Modal";
import { getVideoLink } from "@common/utils/getVideoLink";
import { ModalVideoPlayerContentClassName } from "./ModalVideoPlayer.styled";

export const ModalVideoPlayer = observer(() => {
  const isMobile = useIsMobile();

  const {
    videoPlayerModal: { isOpen, dialogData: video, closeDialog },
    client: {
      showCampaignDialogStore: { campaignData },
      initialDialogStore: { dialogData },
    },
  } = useStores();
  const [adsInfo, setAdsInfo] = useState<boolean>(true);

  const videoLink = getVideoLink(campaignData?.videoLinks, campaignData?.link);
  const link =
    videoLink && videoLink !== campaignData?.productLink
      ? videoLink
      : campaignData?.productLink;

  const resultCampaignData = {
    ...campaignData,
    ...dialogData,
    link,
  };

  if (video?.name) {
    resultCampaignData.name = video?.name;
  }

  if (video?.link) {
    resultCampaignData.name = video?.link;
  }

  if (video?.description) {
    resultCampaignData.name = video?.description;
  }

  return (
    <Modal
      isOpen={isOpen}
      dataCy="диалоговое окно видеоплеера"
      fullScreen={isMobile}
      style={{ overlay: { zIndex: 1101 } }}
    >
      <ModalContentWrapper
        className={ModalVideoPlayerContentClassName}
        fullScreen={isMobile}
        dataCy="модал-контент-враппер"
      >
        <RkVideoMobilePlayer
          src={video?.src}
          thumbnail={video?.thumbnail}
          withThumbnail
          onBackButtonClick={() => closeDialog()}
          showAdsInfo={adsInfo}
          onAdsPreviewClick={() => setAdsInfo(!adsInfo)}
          campaignData={resultCampaignData}
        />
      </ModalContentWrapper>
    </Modal>
  );
});
